import { inject, Injectable } from '@angular/core'
import { firstValueFrom, Observable, of } from 'rxjs'
import { HttpClient, HttpParams } from '@angular/common/http'
import { map } from 'rxjs/operators'
import { Crop, MsSqlPaginatedData } from '@agroone/entities'
import { API_URL } from '../../../models/environment.token'

@Injectable({
  providedIn: 'root',
})
export class CropService {
  public crops?: Crop[]
  private _apiUrl: string = inject(API_URL)
  private _http: HttpClient = inject(HttpClient)

  public async getByGeohash(geohashes: string[], regionName: string): Promise<Crop[]> {
    const pages: MsSqlPaginatedData<Crop>[] = await Promise.all(
      geohashes.map((hash) => {
        const params = new HttpParams().set(
          'filter',
          `region="${regionName}",endDate NOTEXISTS,geohash STARTSWITH "${hash}"`,
        )
        return firstValueFrom(this._http.get<MsSqlPaginatedData<Crop>>(`${this._apiUrl}/crops`, { params }))
      }),
    )
    const result: Crop[] = pages.flatMap((page) => page.data)

    return result
  }

  public getCropBoundaries(crops: Crop[]): Observable<Crop[]> {
    if (crops.length) {
      return this._http
        .get<Crop[]>(`${this._apiUrl}/geolocation/crop/boundaries?ids=${crops.map((i) => i.id).join(',')}`)
        .pipe(
          map((res) => {
            if (res) {
              res = res.filter(Boolean).map((crop) => {
                const c = new Crop(crop as Crop)
                c.cropType = crops.find((x) => x.id === crop.id)?.cropType ?? c.cropType
                return c
              })
              return res
            }
            return []
          }),
        )
    }
    return of([])
  }
}
